import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CurrencySettingModel} from '../../../../models/CurrencySettingModel';
import {CurrencyFilterComponent} from '../../../general-components/filter/currency-filter/currency-filter.component';
import {Offset} from 'src/models/Offset';
import {LoaderService} from 'src/app/general-services/service-loader/loader.service';
import {CurrencyService} from '../../../general-services/service-currency-anagraf/currency.service';
import {forkJoin, Observable} from 'rxjs';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-filter-currency',
  templateUrl: './filter-currency.component.html',
  styleUrls: ['./filter-currency.component.scss']
})
export class FilterCurrencyComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() filter: CurrencySettingModel;

  currencyData: any;
  regionData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(CurrencyFilterComponent, { static: true }) currencyFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;

  filterSingle: CurrencySettingModel;
  offset: Offset;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private currencyService: CurrencyService,
              private regionService: RegionService) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new CurrencySettingModel();
    }
    this.filterSingle = CurrencySettingModel.clone(this.filter);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CURRENCY_SETTING_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CURRENCY_SETTING_FILTER));
    }
    if (this.showNewEditDelete === undefined) {
      this.showNewEditDelete = true;
    }
    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: CurrencySettingModel, isReset?: boolean) {
    const getAllCurrencyObservable: Observable<any> = this.currencyService.getListInCurrencySetting(this.filterSingle).pipe();
    const getAllRegionObservable: Observable<any> = this.regionService.getListInCurrencySetting(this.filterSingle).pipe();

    forkJoin([getAllCurrencyObservable, getAllRegionObservable])
      .subscribe(
        (resultFork: any) => {
          this.currencyData = resultFork[0];
          this.regionData = resultFork[1];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });


  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllCurrencyFilteredObservable: Observable<any> = this.currencyService.getListInCurrencySetting(this.filterSingle).pipe();

    observableList.push(getAllCurrencyFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.currencyData = resultFork[0];

          this.filter.currency = this.filterSingle.currency;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptCurrencyChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.currency = event;


    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInCurrencySetting(this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];

          this.filter.region = this.filterSingle.region;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  filterTable(): void {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.getAllFilters();

    sessionStorage.setItem('currencySettingFilter', JSON.stringify(this.filter));

    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    const isReset = true;
    this.filter = new CurrencySettingModel();
    this.filterSingle = new CurrencySettingModel();

    const getCurrencyObservable: Observable<any> = this.currencyService.getListInCurrencySetting(this.filterSingle).pipe();
    const getRegionObservable: Observable<any> = this.regionService.getListInCurrencySetting(this.filterSingle).pipe();

    forkJoin([getCurrencyObservable, getRegionObservable])
      .subscribe(
        (resultFork: any) => {
          this.currencyData = resultFork[0];
          this.regionData = resultFork[1];

          sessionStorage.setItem(this.SESSION_STORAGE_LABELS.CURRENCY_SETTING_FILTER, JSON.stringify(this.filter));

          this.initFilter(this.filterSingle, isReset);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  getAllFilters() {
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.currency = this.currencyFilterComponent.optionSelected;
  }

  ngOnDestroy(): void {
  }
}

